import { get } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import { useUnsetFocusedFieldProps } from '../../actions/shortcuts';

export const useShortcutPanel = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { id, value, shortcuts = [], changeHandler } = useSelector((state) => get(state, 'shortcuts', {}));
    const unsetFocusedFieldProps = useUnsetFocusedFieldProps();

    React.useEffect(() => {
        const el = document.querySelector(`[name='${id}']`);

        setAnchorEl(el);

        () => {
            unsetFocusedFieldProps();
            setAnchorEl(null);
        };
    }, [id]);

    return { id, shortcuts, value, changeHandler, anchorEl };
};
